import { GlTooltipDirective, GlLink, GlButton, GlSprintf } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __, sprintf } from '~/locale';
import SafeHtml from '~/vue_shared/directives/safe_html';
import defaultAvatarUrl from 'images/no_avatar.png';
import TimeagoTooltip from '../../vue_shared/components/time_ago_tooltip.vue?vue3';
import UserAvatarLink from '../../vue_shared/components/user_avatar/user_avatar_link.vue?vue3';
import UserAvatarImage from '../../vue_shared/components/user_avatar/user_avatar_image.vue?vue3';
import getRefMixin from '../mixins/get_ref';
export default {
    name: 'CommitInfo',
    components: {
        UserAvatarLink,
        TimeagoTooltip,
        GlButton,
        GlLink,
        UserAvatarImage,
        GlSprintf
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        SafeHtml
    },
    mixins: [
        getRefMixin
    ],
    props: {
        commit: {
            type: Object,
            required: true
        },
        span: {
            type: Number,
            required: false,
            default: null
        }
    },
    data () {
        return {
            showDescription: false
        };
    },
    computed: {
        commitDescription () {
            // Strip the newline at the beginning
            return this.commit?.descriptionHtml?.replace(/^&#x000A;/, '');
        },
        avatarLinkAltText () {
            return sprintf(__(`%{username}'s avatar`), {
                username: this.commit.authorName
            });
        },
        truncateAuthorName () {
            return typeof this.span === 'number' && this.span < 3;
        },
        isCommitterDifferentFromAuthor () {
            return this.commit.authorName !== this.commit.committerName || this.commit.authorEmail !== this.commit.committerEmail;
        }
    },
    methods: {
        toggleShowDescription () {
            this.showDescription = !this.showDescription;
        }
    },
    defaultAvatarUrl,
    safeHtmlConfig: {
        ADD_TAGS: [
            'gl-emoji'
        ]
    },
    i18n: {
        toggleCommitDescription: __('Toggle commit description'),
        authoredOnly: __('%{author} authored %{authoredDate}'),
        authoredAndCommitted: __('%{author} authored %{authoredDate} and %{committer} committed %{committedDate}')
    }
};
